<script setup>
const props = defineProps({
  location: {
    type: Object,
    required: true,
  },
  text: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div
    v-if="props?.text?.content"
    class="events-about-location"
  >
    <h2
      v-if="props?.text?.title"
      v-html="props?.text?.title"
    />
    <h3
      v-if="props?.text?.subtitle"
      v-html="props?.text?.subtitle"
    />
    <div
      class="content"
      v-html="props?.text?.content"
    />
  </div>
</template>

<style lang="scss" scoped>
.events-about-location {
  @include body-1-reg;

  color: $wds-color-ink-darker;
  margin-bottom: $wds-spacing-m;

  h2,
  h3,
  :deep(h2),
  :deep(h3) {
    color: $wds-color-ink-darker;
    margin-bottom: $wds-spacing-s;
    text-align: left;
  }

  h3,
  :deep(h3) {
    @include title-5-bld;

    @include tablet {
      @include title-3-bld;
    }
  }

  h2,
  :deep(h2) {
    @include title-2-bld;

    > span {
      color: $wds-color-purple;
    }

    @include tablet {
      @include title-1-bld;

      margin-top: -10px;
    }
  }
}
</style>
